var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Dropdown = require('Dropdown');

var Layout = Marionette.View.extend({
    regions: {
        options: '#options'
    },
    template: '#languageLayout'
});

module.exports.show = function (options) {
    var region = options.region;
    var collection = new Backbone.Collection(_.filter(EY.Consultation.Resources.Enumeration, { type: 'LanguageType', active: true }));
    var layout = new Layout({ collection: collection });
    var user = EY.Consultation.CurrentUser;
    var selection = user.preferences && user.preferences.culture
        || window.localStorage.getItem('consultation-user-culture')
        || EY.Consultation.Lookups.LanguageType["en-US"];

    region.show(layout);
    Dropdown.show({
        collection: collection,
        region: layout.getRegion('options'),
        selection: selection,
        supressEventsOnLoad: true,
        resourceKeyAttribute: 'id',
        onSelectionChanged: function (language) {
            if (language.id !== selection) {
                user.model.save({ preferences: _.extend({}, user.model.get('preferences'), { culture: language.id }) }).done(function() {
                    window.location.reload();
                });
                window.localStorage.setItem('consultation-user-culture', language.id);

            }
        }
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Language.js